export const setSelectedClientLanguages = (updatedClientLanguages) => {

    updatedClientLanguages = updatedClientLanguages.map((clientLanguage) => {
        return clientLanguage.value;
    });

    return updatedClientLanguages;
}

export const setSelectedCountries = (updatedClientCountries) => {
    updatedClientCountries = updatedClientCountries.map((clientCountry) => {
        return clientCountry.value;
    });

    return updatedClientCountries;
}

export const setSelectedIndustries =(updatedClientIndustries ) => {
    updatedClientIndustries = updatedClientIndustries.map((clientIndustry) => {
         return clientIndustry.value;
        //return clientIndustry.value.charAt(0).toUpperCase() +  clientIndustry.value.substr(1).toLowerCase()
    });

    return updatedClientIndustries;
}

export const setSelectedEmailPreferences = (updatedEmailPreferences) => {
    updatedEmailPreferences = updatedEmailPreferences.map((clientEmailPreference) => {
        return clientEmailPreference.value;
   });

   return updatedEmailPreferences;
}